const LOCALE_TO_KEYCODE = {
  en: "en",
  ko: "kr",
  ja: "jp",
  zh: "cn",
  es: "es",
  fr: "fr",
  de: "de",
};

module.exports = {
  i18n: {
    defaultLocale: "en",
    locales: ["en", "ko", "ja", "zh", "es", "fr", "de"],
    localeDetection: false,
  },
  defaultNS: "gnb",
  ns: [
    "gnb",
    "index",
    "software",
    "tactsuit",
    "games",
    "checkout",
    "tracking",
    "shop",
    "support",
    "about",
    "blog",
    "where-to-try",
    "event",
    "trade-in",
  ],
  localePath: (locale, namespace) => {
    const keyCode = LOCALE_TO_KEYCODE[locale] || "en";
    return `./public/translations/${keyCode}/${namespace}.json`;
  },
};
